import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ConsigneeNotifierAdmin } from "src/app/domain/models/ConsigneeNotifierAdmin";


@Injectable({providedIn: 'root'})
export abstract class ConsigneeNotifierAdminGateway {
  abstract uploadConsigneesNotifiers(request: any): Observable<any>
  abstract getAllByCountryIdAndType(countryId: number, type: string): Observable<ConsigneeNotifierAdmin[]>
  abstract assignUser(request: any): Observable<any>
  abstract CreateConsigneeOrNotifierFromUser(request: any): Observable<any>
  abstract exportConsigneesNotifiers(): Observable<any>
}
